import React, { useState, useEffect } from "react";
import NavigationService from "../../services/NavigationService";

import { motion } from "motion/react";
const ListNavigation = () => {
  const [navigation, setNavigation] = useState([]);
  const [currentNavigation, setCurrentNavigation] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
    retrieveNavigation();
  }, []);

  const onChangeSearchTitle = (e) => {
    const searchTitle = e.target.value;
    setSearchTitle(searchTitle);
  };

  const retrieveNavigation = () => {
    NavigationService.getAll()
      .then((response) => {
        setNavigation(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <div className="pb-10  bg-slate-100 w-full">
        <div className="flex flex-row-2 w-full h-16 text-center relative gap-y-80">
          <h1 className="text-4xl lg:text-4xl font-semibold px-10 pt-10">
            {" "}
            Navigations
          </h1>

          <button
            class="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700
      hover:border-blue-500 rounded  absolute top-10 right-0"
          >
            <a
              href={"/admin/navigation/add"}
              className="lg:text-1xl"
            >
              Add New Navigation
            </a>
          </button>
        </div>

        <div className="grid grid-cols-2 px-10 pt-10">
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            class="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full"
          >
            <div class="p-4">
              <div class="divide-y divide-slate-200">
                <table className="table-auto w-full border-spacing-2 ">
                  <tbody>
                    {navigation &&
                      navigation.map((menuitem) => (
                        <tr className="">
                          <td className="w-3/4 border-separate border-b-[0.3px] border-slate-500 py-4">
                            <div>
                              <h6 className="text-slate-800 font-semibold">
                                {menuitem.name}
                              </h6>
                            </div>
                          </td>
                          <td className="border-separate border-b-[0.3px] border-slate-500 py-4">
                            <p className="text-slate-600 text-sm w-36">
                              <p>{menuitem.link}</p>
                            </p>
                          </td>
                          <td className="order-last border-separate border-b-[0.3px] py-4  border-slate-500">
                            <a href={"/admin/navigation/" + menuitem.id}>
                              <button className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                                Edit
                              </button>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ListNavigation;
